export const COINGECKO_BASE_URL = 'https://api.coingecko.com/api/v3';